import type { HTMLComponent } from "@commercekit/react";
import classNames from "classnames";
import type { SelectHTMLAttributes } from "react";
import { useField } from "remix-validated-form";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";

const WvSelectField: HTMLComponent<{
  name: string;
  list: { name: string; value: string }[];
  onChanged?: (v: string) => void;
  defaultIndex?: number;
  placeholder?: string;
  className?: string;
  label?: string;
  inputProps?: SelectHTMLAttributes<HTMLSelectElement>;
  disabled?: boolean;
  defaultValue?: string;
}> = ({
  name,
  list,
  label,
  onChanged,
  className,
  inputProps,
  disabled = false,
  defaultValue,
}) => {
  const { error, validate, clearError } = useField(name);
  const { $pt } = usePrismicLabels();
  return (
    <div className={`col-12 mb-3 ${className}`}>
      <div className="input input--label">
        <select
          {...inputProps}
          defaultValue={defaultValue}
          disabled={disabled}
          className={classNames([
            "form-control",
            { valid: !error },
            { error: error },
          ])}
          name={name}
          onChange={(e) => {
            clearError();
            validate();
            onChanged?.(e.target.value);
          }}
        >
          {list &&
            list?.map((option) => (
              <option key={option?.name} value={option?.value}>
                {option?.name}
              </option>
            ))}
        </select>
        {error ? (
          <label className="error" htmlFor={name}>
            {$pt(error)}
          </label>
        ) : null}
        <span className="input__label">{label} *</span>
      </div>
    </div>
  );
};

export default WvSelectField;
